(function () {
  const SP_HANDLE = 'shipping-protection';
  const ADDON_HANDLES = ['shipping-protection', 'compostable-packaging', 'priority-production'];

  let busy = false;
  let spVariantId = null;

  const getCart = () => fetch('/cart.js').then(r => r.json());

  const addItem = (id, qty) => fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ items: [{ id, quantity: qty }] })
  });

  const changeQty = (key, qty) => fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity: qty })
  });

  // Lấy variant id của Shipping Protection từ product JSON (khỏi hardcode)
  async function getSpVariant() {
    if (spVariantId) return spVariantId;
    const p = await fetch(`/products/${SP_HANDLE}.js`).then(r => r.json());
    spVariantId = p.variants[0].id;
    return spVariantId;
  }

  async function refreshDrawer() {
    const res = await fetch('/?sections=cart-drawer');
    const data = await res.json();
    const doc = new DOMParser().parseFromString(data['cart-drawer'], 'text/html');
    const fresh = doc.querySelector('#CartDrawer');
    const target = document.querySelector('#CartDrawer');
    if (fresh && target) {
      target.innerHTML = fresh.innerHTML;
      bind();
    }
  }

  async function syncProtection() {
    if (busy) return;
    busy = true;
    try {
      const cart = await getCart();
      const mainQty = cart.items
        .filter(i => !ADDON_HANDLES.includes(i.handle))
        .reduce((s, i) => s + i.quantity, 0);

      const sp = cart.items.find(i => i.handle === SP_HANDLE);
      const cur = sp ? sp.quantity : 0;

      if (mainQty === 0) {
        if (cur > 0) await changeQty(sp.key, 0);
      } else if (cur === 0) {
        await addItem(await getSpVariant(), 1);
      } else if (cur > 1) {
        await changeQty(sp.key, 1);
      }
    } finally {
      busy = false;
    }
  }

  function bind() {
    document.querySelectorAll('[data-addon-variant]').forEach(el => {
      if (el.dataset.bound) return;
      el.dataset.bound = '1';
      el.addEventListener('change', async e => {
        const id = parseInt(e.target.dataset.addonVariant, 10);
        e.target.disabled = true;
        busy = true;
        try {
          if (e.target.checked) {
            await addItem(id, 1);
          } else {
            const cart = await getCart();
            const line = cart.items.find(i => i.variant_id === id);
            if (line) await changeQty(line.key, 0);
          }
        } finally {
          busy = false;
        }
        await refreshDrawer();
      });
    });
  }

  const _fetch = window.fetch;
  window.fetch = async function (...args) {
    const r = await _fetch.apply(this, args);
    const url = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url) || '';
    if (!busy && /\/cart\/(add|change|update)\.js/.test(url)) {
      setTimeout(async () => {
        await syncProtection();
        await refreshDrawer();
      }, 80);
    }
    return r;
  };

  document.addEventListener('DOMContentLoaded', () => {
    bind();
    syncProtection();
  });
})();